import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { RecoilRoot } from 'recoil'

import ClassView from './views/ClassView'
import ClassDetailView from './views/ClassDetailView'
import ClassAddView from './views/ClassAddView'
import ClassUpdateView from './views/ClassUpdateView'
import TestLogin from './views/TestLogin'
// import Board from './views/Board'
import { ClassLayout, WhiteBoardLayout } from './components/Layout'
import BoardView from './views/BoardView'
import NotFound from './views/NotFound'
import LoginView from './views/LoginView'
import ResetPasswordView from './views/ResetPasswordView'
import RegisterView from './views/RegisterView'
// import BoardTeacherView from './views/BoardTeacherView'
// import BoardStudentView from './views/BoardStudentView'
// import { getUserProfile } from './apis/member.ts'
// import loginState from './states/loginState.ts'
// import Board from './views/Board.jsx'

// const userList = [
//   { user: 'STUDENT', component: BoardStudentView },
//   { user: 'TEACHER', component: BoardTeacherView },
// ]

// function RequireAuth({ children, redirectTo }) {
//   let locate = useLocation()
//   console.log('Require Auth ' + locate.pathname)

//   // const login = useRecoilValue(loginState)
//   const [login, setLogin] = useRecoilState(loginState)
//   console.log(login)

//   useEffect(() => {
//     async function checkLogin() {
//       let profileRes = await getUserProfile()
//       if (profileRes.error === true) {
//         setLogin({ user: null })
//       } else {
//         setLogin({
//           user: profileRes.data,
//         })
//       }
//     }

//     checkLogin()
//   }, [setLogin])

//   if (login.user) {
//     return children
//   } else if (login.user === null) {
//     return <Navigate to={redirectTo} />
//   } else {
//     return <></>
//   }
// }

// function NoRequireAuth({ children, redirectTo }) {
//   let locate = useLocation()
//   console.log('NoRequire Auth ' + locate.pathname)

//   const [login, setLogin] = useRecoilState(loginState)
//   console.log(login)

//   useEffect(() => {
//     async function checkLogin() {
//       let profileRes = await getUserProfile()
//       if (profileRes.error === true) {
//         setLogin({ isLoggedIn: false })
//       } else {
//         setLogin({
//           isLoggedIn: true,
//         })
//       }
//     }

//     checkLogin()
//   }, [setLogin])

//   if (login.isLoggedIn === false) {
//     return children
//   } else if (login.isLoggedIn === true) {
//     return <Navigate to={redirectTo} />
//   } else {
//     return <></>
//   }
// }

function App() {
  // const [component, setComponent] = useState()
  return (
    // <div className='App'>
    <RecoilRoot>
      <Router>
        <Routes>
          <Route path='/' element={<ClassLayout />}>
            <Route path='/class' element={<ClassView />}></Route>
            <Route path='/class/detail' element={<ClassDetailView />}></Route>
            <Route path='/class/add' element={<ClassAddView />}></Route>
            <Route path='/class/update' element={<ClassUpdateView />}></Route>
            <Route path='/' element={<TestLogin />}></Route>
          </Route>
          <Route path='/board' element={<WhiteBoardLayout />}>
            <Route
              path='/board'
              element={
                // <RequireAuth redirectTo={'/'}>
                // <BoardView />
                <BoardView />
                // </RequireAuth>
              }
            ></Route>
            {/* 
            <Route path='/board/teacher' element={<BoardTeacherView />}></Route>
            <Route path='/board/student' element={<BoardStudentView />}></Route> */}
          </Route>
          <Route path='*' element={<NotFound />}></Route>
          <Route path='/login' element={<LoginView />}></Route>
          <Route path='/password' element={<ResetPasswordView />}></Route>
          <Route path='/register' element={<RegisterView />}></Route>
        </Routes>
      </Router>
    </RecoilRoot>
    // </div>
  )
}

export default App
